import React, { useEffect, useState } from "react";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";

const DEFAULT_CENTER = { lat: 53.4, lng: -7.7 }; // Central Ireland

export default function IrelandMap({ zipcodes = [] }) {
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!zipcodes.length) {
      setLocations([]);
      return;
    }

    const apiKey = process.env.REACT_APP_GEO_KEY;

    const fetchAllGeocodes = async () => {
      setError("");
      const results = await Promise.all(
        zipcodes.map(async (zipcode) => {
          try {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
                zipcode
              )}&key=${apiKey}`
            );
            const data = await response.json();
            if (data.status === "OK" && data.results.length > 0) {
              const { lat, lng } = data.results[0].geometry.location;
              return { zipcode, lat, lng };
            } else {
              return null;
            }
          } catch {
            return null;
          }
        })
      );
      const validResults = results.filter(Boolean);
      setLocations(validResults);
      if (validResults.length === 0) {
        setError("No valid locations found for the provided Eircodes.");
      }
    };

    fetchAllGeocodes();
    // eslint-disable-next-line
  }, [JSON.stringify(zipcodes)]);

  // Use first location as initial center, or default
  const initialCenter =
    locations.length > 0
      ? { lat: locations[0].lat, lng: locations[0].lng }
      : DEFAULT_CENTER;

  return (
    <div className="w-[calc(100%-2rem)] m-4">
      <APIProvider apiKey={process.env.REACT_APP_GEO_KEY}>
        <Map
          style={{ width: "100%", height: "650px" }}
          defaultCenter={initialCenter}
          defaultZoom={locations.length > 0 ? 10 : 7}
          options={{
            zoomControl: true,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: true,
            fullscreenControl: true,
            draggable: true,
            scrollwheel: true,
            disableDoubleClickZoom: false,
            gestureHandling: "auto",
          }}
        >
          {locations.map((loc, idx) => (
            <Marker
              key={loc.zipcode + idx}
              position={{ lat: loc.lat, lng: loc.lng }}
            />
          ))}
        </Map>
        {error && <div className="text-red-600 mt-2 font-medium">{error}</div>}
      </APIProvider>
    </div>
  );
}
